/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgeUnitoBasecampProdIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-basecamp-prod" */ './utils').then(
			(m) => m.ForgeUnitoBasecampProdIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-basecamp-prod/icon' },
);

const LazyForgeUnitoBasecampProdSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-basecamp-prod-search-result" */ './utils').then(
			(m) => m.ForgeUnitoBasecampProdSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-basecamp-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeUnitoBasecampProdIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoBasecampProdIconComponent />
	</Suspense>
);

export const ForgeUnitoBasecampProdSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoBasecampProdSearchResultIconComponent />
	</Suspense>
);
